// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { assembleQuery, postProjectWarningsJob } from 'helpers/api'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'
import { documentGenerationNotification } from 'components/Notifications'
import { updateProjectSettings } from 'redux/modules/projectSummary'

const getProjectWarnings = (projectId, reportTypes, closeContextModal) => async (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const query = assembleQuery([{
        field: 'reportTypes',
        value: reportTypes.join(','),
      }])

      try {
        if (reportTypes.length === 0) {
          throw new Error('Must select at least one report type')
        }
        const { entity } = await postProjectWarningsJob(projectId, query)
        dispatch(documentGenerationNotification(entity))
        closeContextModal()
        // if true, that means we're currently in the project summary subtree
        // and that we want to flip this flag in redux state.
        // the DB wont have this flag flipped until after the document has
        // finished generating but we want to flip it immediately.
        // this way as the user navigates through the project summary subtree,
        // they will continue to see this checked, regardless of wether or not this
        // document was completed at the time of mounting.
        // See LEGO-5717 for further explanation.
        if (projectId === getState().projectSummary.get('projectId')) {
          dispatch(updateProjectSettings({ warningsCheck: true }))
        }
      } catch (err) {
        // we throw this error so the caller knows it failed.
        throwSubmissionError(err)
      }
    })
  )
)

export default getProjectWarnings
